/**
 * Created by zzy on 2019/8/5.
 */
import BroadcastSystem from './BroadcastSystem.vue'
export default BroadcastSystem



// WEBPACK FOOTER //
// ./src/views/monitoring/BroadcastSystem/index.js